export enum SuggestedListStatusEnum {
  ALL,
  VALID,
  INVALID,
}
